import Vue from "vue";

Vue.filter("translateGoogleFreeText", function(itemFreeTextFields, fieldId, lang)
{
    var returnVal = "";

    lang = typeof (lang) === "undefined" ? "de" : lang.toString();
    lang = lang.toLowerCase();

    if (typeof (itemFreeTextFields[fieldId]) !== "undefined")
    {
        var fieldToTranslate = itemFreeTextFields[fieldId];

        returnVal = fieldToTranslate;
        if (typeof (itemFreeTextFields.free17) !== "undefined" && itemFreeTextFields.free17 === "1")
        {
            var fieldSplit = fieldToTranslate.split("|");

            if (fieldSplit.length > 1)
            {
                if (lang !== "de")
                {
                    returnVal = fieldSplit[1];
                }
                else
                {
                    returnVal = fieldSplit[0];
                }
            }
            else
            {
                returnVal = fieldSplit[0];
            }
        }
    }

    return returnVal;
});
